import React, {type FC} from 'react';
import s from './ProductQuickAddAddToCartButton.scss';
import {withGlobals, useGlobals} from '../../../../../../globalPropsContext';
import {IProduct} from '../../../../../../types/galleryTypes';
import {useProductQuickAddAddToCartButtonType} from './hooks/useProductQuickAddAddToCartButtonType';
import {useProductQuickAddAddToCartButtonText} from './hooks/useProductQuickAddAddToCartButtonText';
import {BaseAddToCartButton} from '../../../../BaseAddToCartButton/BaseAddToCartButton';

export enum ProductQuickAddAddToCartButtonDataHook {
  Root = 'product-quick-add-add-to-cart-button',
}

export interface IProductQuickAddAddToCartButtonProps {
  product: IProduct;
  quantity: number;
  canAddProductToCart: boolean;
}

const ProductQuickAddAddToCartButtonComp: FC<IProductQuickAddAddToCartButtonProps> = ({
  product,
  quantity,
  canAddProductToCart,
}) => {
  const {handleQuickAddToCart} = useGlobals();

  const buttonText = useProductQuickAddAddToCartButtonText(product.id, canAddProductToCart);
  const buttonType = useProductQuickAddAddToCartButtonType();

  return (
    <BaseAddToCartButton
      className={s.quickAddAddToCartButton}
      dataHook={ProductQuickAddAddToCartButtonDataHook.Root}
      product={product}
      contentType={buttonType}
      onClick={() => void handleQuickAddToCart({product, productId: product.id, quantity})}
      disabled={!canAddProductToCart}
      text={buttonText}
      isQuickAdd={true}
    />
  );
};

export const ProductQuickAddAddToCartButton = withGlobals(ProductQuickAddAddToCartButtonComp);
